/* One native Shopify localization POST; no redirect while editing. */
(() => {
  const dialog = document.getElementById('psny-region-dialog');
  if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const form = dialog.querySelector('form');
  const country = form.querySelector('[name="country_code"]');
  const locale = form.querySelector('[name="locale_code"]');
  const radios = [...form.querySelectorAll('[name="psny_region_language"]')];
  const markets = JSON.parse(dialog.querySelector('[data-region-markets]').textContent);
  const normalize = value => /^zh/i.test(value) ? 'zh-TW' : value.toLowerCase();
  const current = { country: dialog.dataset.currentCountry, language: normalize(dialog.dataset.currentLanguage) };
  const currentMarket = markets[current.country];
  const initiallyExplicit = !!currentMarket && current.language !== currentMarket.default;
  let explicit = initiallyExplicit;
  let opener;
  let interacted = false;
  const preferenceKey = 'psny-region-choice-v1';
  const visitKey = 'psny-region-first-visit-v1';
  const readPreference = () => {
    try { return JSON.parse(localStorage.getItem(preferenceKey) || 'null'); } catch (_) { return null; }
  };
  function remember() {
    try {
      localStorage.setItem(preferenceKey, JSON.stringify({ country: country.value, language: locale.value }));
    } catch (_) { /* The selector remains usable when storage is blocked. */ }
  }
  function markSeen() {
    try { localStorage.setItem(visitKey, '1'); return localStorage.getItem(visitKey) === '1'; }
    catch (_) { return false; }
  }

  const picker = form.querySelector('.psny-region-picker');
  const countryButton = picker.querySelector('button');
  const countryList = picker.querySelector('[role="listbox"]');
  const countryOptions = [...countryList.querySelectorAll('[role="option"]')];
  function closeCountries(restore = false) {
    countryList.hidden = true;
    countryButton.setAttribute('aria-expanded', 'false');
    if (restore) countryButton.focus();
  }
  function openCountries() {
    countryList.hidden = false;
    countryButton.setAttribute('aria-expanded', 'true');
    (countryOptions.find(option => option.dataset.regionOption === country.value) || countryOptions[0]).focus();
  }
  countryButton.addEventListener('click', () => countryList.hidden ? openCountries() : closeCountries(true));
  countryButton.addEventListener('keydown', event => {
    if (['ArrowDown', 'ArrowUp'].includes(event.key)) { event.preventDefault(); openCountries(); }
  });
  countryOptions.forEach(option => option.addEventListener('click', () => {
    country.value = option.dataset.regionOption;
    update(true);
    closeCountries(true);
  }));
  picker.addEventListener('keydown', event => {
    if (countryList.hidden) return;
    const index = countryOptions.indexOf(document.activeElement);
    let next;
    if (event.key === 'ArrowDown') next = (index + 1) % countryOptions.length;
    if (event.key === 'ArrowUp') next = (index - 1 + countryOptions.length) % countryOptions.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = countryOptions.length - 1;
    if (next !== undefined) { event.preventDefault(); countryOptions[next].focus(); }
    if (['Enter', ' '].includes(event.key) && index >= 0) { event.preventDefault(); countryOptions[index].click(); }
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); closeCountries(true); }
    if (event.key === 'Tab') closeCountries();
  });
  picker.addEventListener('focusout', event => { if (!picker.contains(event.relatedTarget)) closeCountries(); });
  dialog.addEventListener('click', event => { if (!picker.contains(event.target)) closeCountries(); });

  function update(fromCountry = false) {
    const market = markets[country.value];
    // Unknown destinations must not inherit a guessed language configuration.
    const supported = market ? market.languages : [current.language];
    let selected = radios.find(input => input.checked)?.value || current.language;
    const unavailable = !supported.includes(selected);
    // A destination change starts a new choice: suggest its default, then allow override.
    if (fromCountry) { selected = market?.default || current.language; explicit = false; }
    radios.forEach(input => { input.disabled = !supported.includes(input.value); input.checked = input.value === selected; });
    locale.value = selected;
    countryOptions.forEach(option => option.setAttribute('aria-selected', String(option.dataset.regionOption === country.value)));
    const selectedOption = countryOptions.find(option => option.dataset.regionOption === country.value);
    if (selectedOption) dialog.querySelector('[data-region-country-display]').replaceChildren(...[...selectedOption.childNodes].map(node => node.cloneNode(true)));
    dialog.querySelector('[data-region-currency]').textContent = country.selectedOptions[0].dataset.currency;
    dialog.querySelector('[data-region-note]').textContent = unavailable && fromCountry
      ? dialog.dataset.unavailableNote : explicit ? dialog.dataset.keptNote : dialog.dataset.defaultNote;
  }

  function position() {
    if (!dialog.open || !opener || window.matchMedia('(max-width:749px)').matches) return;
    const rect = opener.getBoundingClientRect();
    const width = dialog.getBoundingClientRect().width;
    const height = dialog.getBoundingClientRect().height;
    dialog.style.left = `${Math.max(16, Math.min(rect.right - width, window.innerWidth - width - 16))}px`;
    dialog.style.top = `${Math.max(16, Math.min(rect.bottom + 8, window.innerHeight - height - 16))}px`;
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-region-open]');
    if (!trigger) return;
    interacted = true;
    opener = trigger;
    const drawer = trigger.closest('header-drawer');
    // Dawn binds drawer buttons as close controls; intercept only this trigger.
    if (drawer) event.stopPropagation();
    // Retain the drawer as context behind the modal; closing restores this trigger.
    dialog.dataset.regionOrigin = drawer ? 'drawer' : 'page';
    closeCountries();
    country.value = current.country;
    radios.forEach(input => { input.checked = input.value === current.language; });
    explicit = initiallyExplicit;
    update();
    dialog.showModal();
    document.body.classList.add('psny-region-open');
    position();
  }, { capture: true });
  dialog.querySelectorAll('[data-region-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => { document.body.classList.remove('psny-region-open'); opener?.focus(); });
  country.addEventListener('change', () => update(true));
  radios.forEach(input => input.addEventListener('change', () => { explicit = true; update(); }));
  form.addEventListener('submit', () => {
    update();
    remember();
    markSeen();
    const returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = window.location.pathname + window.location.search;
  });
  document.addEventListener('pointerdown', () => { interacted = true; }, { once: true, capture: true });
  document.addEventListener('keydown', () => { interacted = true; }, { once: true, capture: true });
  async function firstVisit() {
    // Explicit language URLs, saved choices and the theme editor always win.
    const languagePath = /^\/(?:en|id|zh-tw|ja)(?:-[a-z]{2})?(?:\/|$)/i.test(location.pathname);
    let seen;
    try { seen = localStorage.getItem(visitKey); } catch (_) { /* No automatic POST without a loop guard. */ }
    if (window.Shopify?.designMode || languagePath || readPreference() || seen) return;
    const browserLanguage = (navigator.languages?.[0] || navigator.language || '').toLowerCase();
    const language = /^ja(?:-|$)/.test(browserLanguage) ? 'ja'
      : /^id(?:-|$)/.test(browserLanguage) ? 'id'
      : /^zh-(?:tw|hk|hant)(?:-|$)/.test(browserLanguage) ? 'zh-TW' : 'en';
    let destination = current.country;
    let detected = false;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 2500);
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}browsing_context_suggestions.json?country[enabled]=true`, {
        signal: controller.signal, headers: { Accept: 'application/json' }
      });
      if (response.ok) {
        const data = await response.json();
        const suggested = data.detected_values?.country?.handle || data.suggestions?.[0]?.parts?.country?.handle;
        if (markets[suggested] && [...country.options].some(option => option.value === suggested)) {
          destination = suggested;
          detected = true;
        }
      }
    } catch (_) { /* Fall back to a choice, never guess a destination from language. */ }
    finally { clearTimeout(timeout); }
    // Do not interrupt a customer who started interacting while the request was pending.
    if (interacted || dialog.open || document.querySelector('header-drawer details[open]')) return;
    const supported = markets[destination]?.languages || [];
    country.value = destination;
    radios.forEach(input => { input.checked = input.value === (supported.includes(language) ? language : current.language); });
    explicit = true;
    update();
    const persisted = markSeen();
    if (language !== 'en' && detected && supported.includes(language) && persisted) {
      if (destination !== current.country || language !== current.language) form.requestSubmit();
      return;
    }
    opener = [...document.querySelectorAll('[data-region-open]')].find(button => button.getClientRects().length);
    dialog.dataset.regionOrigin = 'page';
    // An English browser may arrive on the Japanese root URL. Make its first choice readable.
    if (language === 'en') {
      const englishLabels = [
        ['#psny-region-title', 'Ship to · Language'],
        ['#psny-region-country-label', 'Ship to'],
        ['.psny-region-languages .psny-region-field-label', 'Language'],
        ['.psny-region-currency > span:first-child', 'Currency'],
        ['.psny-region-apply', 'Apply']
      ];
      englishLabels.forEach(([selector, text]) => {
        const element = dialog.querySelector(selector);
        if (!element) return;
        const textNode = [...element.childNodes].reverse().find(node => node.nodeType === 3 && node.textContent.trim());
        if (textNode) textNode.textContent = text;
      });
      dialog.querySelector('[data-region-close]').setAttribute('aria-label', 'Close');
      if (typeof Intl.DisplayNames === 'function') {
        const names = new Intl.DisplayNames(['en'], { type: 'region' });
        countryOptions.forEach(option => { option.querySelector('span:last-child').textContent = names.of(option.dataset.regionOption); });
        update();
      }
    }
    dialog.showModal();
    document.body.classList.add('psny-region-open');
    position();
  }
  firstVisit();
  window.addEventListener('resize', position);
  document.querySelectorAll('[data-region-open]').forEach(button => { button.hidden = false; });
})();
